<template>
	<div class="phisherLogo">
		<img src="@/assets/phisher.svg">
		<div class="threatMap">Threat Map</div>
	</div>
</template>

<script>
	export default {
		name: "PhishER",
	};
</script>

<style scoped>
	.phisherLogo {
		position: absolute;
		top: 38px;
		left: 45%;
		z-index: 1;
	}

	img {
		height: 60px;
	}

	.threatMap {
		margin-top: -8px;
		color: #fff;
		font-size: 2em;
		font-family: 'Helvetica Neue', sans-serif;
		font-weight: 300;
		letter-spacing: .1em;
		text-align: right;
	}
</style>
